import React, {ReactElement} from "react";
import {ILanguageTokens} from "../../localization/LanguageTokens";
import {connect} from "react-redux";
import {FormControlLabel, styled, Switch} from "@mui/material";
import {RootState} from "../../redux/store";
import {setTheme, THEME_TOKEN} from "../../redux/slice/themeSlice";

const Root = styled(FormControlLabel)(({theme}) => ({
	margin: 0,
	borderRadius: theme.spacing(0.5),
	whiteSpace: 'nowrap',
	'& .MuiSwitch-switchBase': {
		'&.Mui-checked': {
			color: theme.palette.text.secondary,
			'& .MuiSwitch-thumb:before': {
			},
			'& + .MuiSwitch-track': {
				opacity: 1,
				backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : theme.palette.text.secondary,
			},
		},
	},
	'& .MuiFormControlLabel-label': {
		width: 'auto',
		color: theme.palette.text.secondary,
		paddingRight: theme.spacing(1.5),
	}
}));

interface IProps {
	languageTokens: ILanguageTokens;
	isDark: boolean;
	setTheme: (themeToken: THEME_TOKEN) => void;
}

function ThemeSwitch(props: IProps): ReactElement {
		const { languageTokens, isDark, setTheme } = props;

		const handleChangeTheme = () => {
			setTheme(isDark ? THEME_TOKEN.LIGHT : THEME_TOKEN.DARK);
		}

		return <Root
			aria-label={isDark ? 'To Light' : 'To Dark'}
			control={<Switch checked={isDark}/>}
			label={isDark ? languageTokens.DarkMode : languageTokens.BrightMode}
			onChange={handleChangeTheme}
			color={'theme.text.secondary'}
		/>
}

const mapStateToProps = (state: RootState) => ({
	languageTokens: state.language.languageTokens,
	isDark: state.theme.isDark,
});

const mapActionsToProps = {
	setTheme,
};


export default connect(mapStateToProps, mapActionsToProps)(ThemeSwitch);
